/**
 * This matches the initial route loaded on router.currentRoute until the
 * correct route resolves.
 */
const initialRoute = {
    fullPath: '/',
    hash: '',
    matched: [],
    meta: {},
    name: null,
    params: {},
    path: '/',
    query: {},
};

export { initialRoute };
